@let filesCollection = filesEc;
@let management = filesCollection.management;
@let managementSelectors = management.selectors;
@let isSharedMode = managementSelectors.isSharedMode.asSignal();
@let targetType = managementSelectors.targetType.asSignal();
@let isZoneTarget = targetType === targetTypes.Zone;
@let tenants = managementSelectors.tenants.asSignal();
@let tenantItems = getTenantItems(tenants);
@let tenantsLoading = managementSelectors.isLoadingTenants.asSignal();
@let tenantsError = managementSelectors.tenantsError.asSignal();
@let selectedTenantId = managementSelectors.selectedTenantId.asSignal();
@let zones = managementSelectors.zones.asSignal();
@let zoneItems = getZoneItems(zones);
@let zonesLoading = managementSelectors.isLoadingZones.asSignal();
@let zonesError = managementSelectors.zonesError.asSignal();
@let selectedZoneId = managementSelectors.selectedZoneId.asSignal();
@let target = managementSelectors.target.asSignal();

<div class="atn-admin-knowledge-bases-shared-tab">
  <atn-ds-widget title="Shared document audience">
    <div class="atn-admin-knowledge-bases-shared-tab__target-policy">
      Choose one exact Tenant or Zone audience to browse and upload its
      documents.
    </div>

    <div class="atn-admin-knowledge-bases-shared-tab__selectors">
      <atn-ds-select-single
        label="Availability"
        [items]="targetTypeItems"
        [required]="true"
        [value]="targetType"
        (valueChange)="
          management.actions.selectTargetType
            .from('Admin.KnowledgeBases.Shared.TargetType.Selected')
            .dispatch($event)
        "
      />

      @if (targetType) {
        <atn-ds-select-single
          label="Tenant"
          [error]="tenantsError"
          [items]="tenantItems"
          [loading]="tenantsLoading"
          [required]="true"
          [value]="selectedTenantId"
          (valueChange)="
            management.actions.selectTenant
              .from('Admin.KnowledgeBases.Shared.Tenant.Selected')
              .dispatch($event)
          "
          (refetch)="
            management.actions.loadTenants.request
              .from('Admin.KnowledgeBases.Shared.Tenants.Refetched')
              .dispatch()
          "
        />
      }

      @if (isZoneTarget && selectedTenantId) {
        <atn-ds-select-single
          label="Zone"
          [error]="zonesError"
          [items]="zoneItems"
          [loading]="zonesLoading"
          [required]="true"
          [value]="selectedZoneId"
          (valueChange)="
            management.actions.selectZone
              .from('Admin.KnowledgeBases.Shared.Zone.Selected')
              .dispatch($event)
          "
          (refetch)="
            management.actions.loadZones.request
              .from('Admin.KnowledgeBases.Shared.Zones.Refetched')
              .dispatch({ tenantId: selectedTenantId })
          "
        />
      }
    </div>
  </atn-ds-widget>

  @if (isSharedMode && target) {
    <atn-admin-knowledge-bases-page-document-upload />

    <div class="atn-admin-knowledge-bases-shared-tab__documents">
      <atn-ds-table [config]="documentsTableConfig" />
    </div>
  }
</div>
